import React from 'react';

import { useIsMobile } from 'components';

import { toDateNumber } from 'src/utils/dateTime';
import { getFormattedAmount } from 'src/utils/helpers';

import style from '../../TableWithPagination.module.scss';

const Thumbnail = ({ item }) => {
  const { public_id, price, producer_name, qty, unit, created_at } = item || {};
  const isTabletWidth = useIsMobile(768);

  return (
    <div className={style.order}>
      <p>#{public_id}</p>
      <p>{producer_name}</p>
      <p>{getFormattedAmount(price)}</p>
      {!isTabletWidth && (
        <>
          <p>
            {qty} {unit}
          </p>
          <p>{getFormattedAmount(price * qty)}</p>
          <p>{toDateNumber(created_at)}</p>
        </>
      )}
    </div>
  );
};

export default Thumbnail;
